// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"96b9de48","361":"d231bfea","511":"05cf524c","767":"148c94ad"}[chunkId] + ".chunk.js";
};